import { useState } from "react";

export default function Header() {
  const [cartCount] = useState(0);

  return (
    <header className="bg-white border-b border-gray-200 w-full">
      <div className="w-full px-4 flex items-center justify-between h-12">
        {/* Logo */}
        <div className="flex items-center gap-0 shrink-0">
          <span className="text-red-600 font-black text-lg leading-none tracking-tighter">&gt;&gt;</span>
          <span className="font-black text-lg leading-none tracking-tight text-black">TICKET</span>
          <span className="font-black text-lg leading-none tracking-tight text-red-600">LINE</span>
        </div>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-6 ml-6">
          <a href="#" className="text-sm font-semibold text-gray-800 hover:text-red-600 whitespace-nowrap">INÍCIO</a>
          <a href="#" className="text-sm font-semibold text-gray-800 hover:text-red-600 whitespace-nowrap">AGENDA</a>
          <a href="#" className="text-sm font-semibold text-gray-800 hover:text-red-600 whitespace-nowrap">SALAS</a>
          <a href="#" className="text-sm font-semibold text-gray-800 hover:text-red-600 whitespace-nowrap">LIVE STAGE</a>
          <a href="#" className="text-sm font-semibold text-red-600 hover:text-red-700 whitespace-nowrap">STREAMING</a>
        </nav>

        {/* Search + Cart */}
        <div className="flex items-center gap-2 ml-auto">
          <div className="flex items-center border border-gray-300 bg-white">
            <input
              type="text"
              placeholder="Pesquisa"
              className="text-sm px-2 py-1 outline-none w-48 text-gray-700 placeholder-gray-400"
            />
            <button className="px-2 py-1 bg-gray-100 border-l border-gray-300 cursor-pointer">
              <i className="ri-search-line text-gray-600 text-sm"></i>
            </button>
          </div>
          <button className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white text-xs font-bold px-3 py-1.5 cursor-pointer whitespace-nowrap">
            CARRINHO
            <span className="bg-white text-gray-700 text-xs font-bold w-5 h-5 flex items-center justify-center">
              {cartCount}
            </span>
          </button>
        </div>
      </div>
      {/* Advanced search link */}
      <div className="w-full flex justify-end pr-4 pb-1">
        <a href="#" className="text-xs text-gray-500 hover:underline">PESQUISA AVANÇADA</a>
      </div>
    </header>
  );
}
